import { HomeBanner } from './components/HomeBanner';
import { preFixImgUrl } from '@/utils';
import { ServiceEntry } from './components/ServiceEntry';
import { HanedaProductFlow } from './components/HanedaProductFlow';
import { NearbyCoupons } from './components/NearbyCoupons';
import { SagawaLogistics } from './components/SagawaLogistics';
import { VipReservation } from './components/VipReservation';
import { LogoMarquee } from '@/components';
import { AiTripPlanner } from './components/AiTripPlanner';
import { WhyChooseBilionPass } from './components/WhyChooseBilionPass';
import { BrandWall } from './components/BrandWall';
import { HomeAppCta } from './components/HomeAppCta';

const HOME_CONTENT_TEXT_BG = preFixImgUrl('7516e41169e457fb78c22a4ca6e60f6b.jpg', false);
const HOME_CONTENT_BG = preFixImgUrl('372e9e1928d842bd851dd9ede17f5982.png', false);
const HOME_CONTENT_BG_START = 380;

const Home = () => {
  return (
    <div className="min-w-[1200px] bg-[#FAFAFA]">
      <HomeBanner />
      <div
        className="min-h-[1200px]"
        style={{
          backgroundImage: `url(${HOME_CONTENT_TEXT_BG}), url(${HOME_CONTENT_BG})`,
          backgroundPosition: `top center, center ${HOME_CONTENT_BG_START}px`,
          backgroundRepeat: 'no-repeat, no-repeat',
          backgroundSize: '1920px auto, 100% auto',
        }}
      >
        <ServiceEntry />
        <HanedaProductFlow />
        <NearbyCoupons />
        <SagawaLogistics />
        <VipReservation />
        <div className="pt-[98px]">
          <LogoMarquee />
        </div>
        <AiTripPlanner />
        <WhyChooseBilionPass />
        {/* <BrandWall /> */}
        <div className="pt-[98px] pb-[28px]">
          <LogoMarquee />
        </div>
        <HomeAppCta />
      </div>
    </div>
  );
};

export default Home;
